import { StickerBar } from '../shared/icons/StickerBar'
import { StickerBarFailure } from '../shared/icons/StickerBarFailure'
import {
  BigImg,
  ButtonIcon,
  ButtonText,
  HeaderThree
} from './styled-components'
import type { UIConfigType } from './types'

const SUCCESS_UI_CONFIG: UIConfigType = {
  goodNews: (<HeaderThree>Good news</HeaderThree>),
  nextSteps: ' What to expect next',
  nextStepsCopy: {
    pre: 'A confirmation email will be sent to ',
    post: ' If you don\'t receive this email within 2 hours, you can contact your Claim ' +
    'professional directly.'
  },
  info: {
    pre: 'Your files for Claim Number  ',
    post: '  have been submitted to our system.'
  },
  icon: (<BigImg style={{ height: 225, width: 300 }}>
    <StickerBar width="400px" height="200px" />
  </BigImg>),
  backButtonText: (<ButtonText><ButtonIcon></ButtonIcon>{'SUBMIT MORE FILES'}</ButtonText>),
}

const FAILURE_UI_CONFIG: UIConfigType = {
  goodNews: 'Good news (Failure)',
  nextSteps: ' What to expect next',
  nextStepsCopy: {
    pre: 'Some of your files for Claim Number ',
    post:
      'cannot be uploaded. Please try again or contact your Claim professional for assistance.'
  },
  info: {
    pre: 'Some of your files for Claim Number ',
    post:
      '  cannot be uploaded. Please try again or contact your Claim professional for assistance.'
  },
  icon: (<BigImg style={{ height: 225, width: 300 }}>
    <StickerBarFailure width="365px" height="200px" />
  </BigImg>),
  backButtonText: (<ButtonText><ButtonIcon />{'RETRY FILES'}</ButtonText>),
}

const PARTIAL_FAILURE_UI_CONFIG: UIConfigType = {
  goodNews: 'Good news (Partial Success)',
  nextSteps: ' What to expect next',
  nextStepsCopy: {
    pre: 'A confirmation email will be sent to ',
    post: ' If you don\'t receive this email within 2 hours, you can contact your Claim ' +
      'professional directly.'
  },
  info: {
    pre: 'Some of your files for Claim Number  ',
    post: '  cannot be uploaded. Please try again or contact your Claim professional for ' +
      'assistance.'
  },
  icon: (<BigImg style={{ height: 225, width: 300 }}>
    <StickerBarFailure width="365px" height="200px" />
  </BigImg>),
  backButtonText: (<ButtonText><ButtonIcon></ButtonIcon>{'RETRY FILES'}</ButtonText>),
}
const TRACKING_FAILURE_UI_CONFIG: UIConfigType = {
  info: {
    pre: 'Your files for Claim Number  ',
    post: ' have been submitted to our system. Please contact your Claim professional to ' +
      'confirm they have been received.'
  },
  icon: (<BigImg style={{ height: 225, width: 300 }}>
    <StickerBar width="365px" height="200px" />
  </BigImg>),
  backButtonText: (<ButtonText><ButtonIcon></ButtonIcon>{'SUBMIT ANOTHER FILE'}</ButtonText>),
}


export {
  FAILURE_UI_CONFIG,
  PARTIAL_FAILURE_UI_CONFIG,
  SUCCESS_UI_CONFIG,
  TRACKING_FAILURE_UI_CONFIG
}
